/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component} from "react";
import { connect } from "react-redux";
import {useSearchParams} from 'react-router-dom';
import { Helpers, Redux, Templates } from "@ora/recursos";
import axios from "axios";
import 'bulma/css/bulma.min.css';
import qs from "query-string";

const { set_datapage, getMapStateDefault } = Redux.Actions.DataPageAction;
const { baseUrl, baseUrlModule, localUrl } = Helpers.Url;
const { checkDataDirectorio, seDatatDocumentos } =
  Redux.Actions.DirectoriosActions;

const VIEW_SESSION_NAME = "NOMBRE_UNICO_PARA_LAVISTA_ACTUAL_PUBLIC";


class Public extends Component {
  requestInit = null;
  state = {
    lista: [],
  };
  constructor(props) {
    super(props);

    this.requestInit = axios.CancelToken.source();
    //opcional
    // this.props.checkDataDirectorio(VIEW_SESSION_NAME).then((resCheck) => {
    //   if (!resCheck.success) {
    //     this.__getDataInitial();
    //   } else {
    //     this.initpage(resCheck.data);
    //   }
    // });
  }

  __getDataInitial() {
    axios
      .get(baseUrlModule("listaprueba"), {
        params: {
          // especie: this.props.especie.pli_int_id,
          // id: this.props.especie.pli_int_id,
          // onlyquery: false,
          // variables_distribution: this.variables_distribution
        },
        cancelToken: this.requestInit.token,
      })
      .then((res) => {
        if (res.data.success) {
          let _preData = {
            session: VIEW_SESSION_NAME,
            data: res.data.data,
            time: Date.now(),
          };
          this.props
            .seDatatDocumentos(_preData)
            .then((resSet) => {
              this.initpage(_preData);
            })
            .catch((err) => {});
        }
      });
  }

  initpage(result) {
    //DATOS NECESARIOS PARA LA VISTA POR DEFECTO, SOLO SI FUERAN ENCESARIOS
    // this.setState({
    //   lista: result.data,
    // });
  }
  componentDidMount() {
    this.setDataPage();
    var params = qs.parse(this.props.location.search);
    var detalle=params['familia'];
    var type=params['type'];
    console.log(type);
    axios.get(baseUrlModule("reportes/familylist?family="+detalle+"&type="+type+'&d=0')).then((res) => {
      this.setState({
        lista: res.data.especies,
      });
    });


  }

  componentWillUnmount() {
    if (this.requestInit) this.requestInit.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (100 === +this.props.countDataPage) {
      this.setDataPage();
    }
  }

  information=()=>{
    var c=1;

    return this.state.lista.map((item)=>{

        return <tr>
            <th>{c++}</th>
            <th><i>{item.especie}</i></th>
            <th>{item.pli_txt_family}</th>
            <th>{item.cantidad}</th>
            <th>{item.cite}</th>
            <th>{item.uicn}</th>
            <th>{item.comun}</th>
            <th><a target="_blank" href={"https://oraotca.org/biodiversidad/reportes/especies/dashboard/?especie="+item.pli_int_id}><button class="button is-success">{this.props.language('dashboar_citesv2_verficha')}</button></a></th>
        </tr>
    })


  }


  titulo=()=>{
    var params = qs.parse(this.props.location.search);
    var detalle=params['familia'];
    var type=params['type'];
    var reino=params['reino'];
    var ori="";

    if(type=='exports_cites.org'){
        ori="CITES.ORG";       

    }else{
        ori="Instituciones Oficiales de los Países Miembros"
    }


    return <div>
        <h3><b>{this.props.language('reino')}:</b> {reino}</h3>
        <h3><b>{this.props.language('familia')}:</b> {detalle}</h3>
        <h3><b>{this.props.language('dashboar_citesv2_origendatos')}</b> {ori} </h3>
    </div>

  }

  examplePost = () => {
    let data = {};
    axios
      .post(baseUrl("aro/downloads"), data, {
        cancelToken: this.requestInit.token,
      })
      .then((resCre) => {});
  };

  setDataPage = () => {
    this.props.set_datapage({
      titulo: this.props.language('dashboar_citesv2_ficha'),
      isbackend: false,
      hasBreadcrumb: false,
      hasHeroBar: true,
      be_itemselect: "exportaciones_cites", //clave de item del menu backend que se debe activar
      breadcrumb: [
        { name: "Inicio", url: localUrl("/") },
        { name: "Reportes", url: "#" },
        { name: "Biodiversidad", url: "#", active: true },
      ],
    });
  };

  urlWithPublicToken = () => {
    return baseUrl(
      `nombremoduloejemplo/public/anyword?token=${Helpers.ValidationAuth.getPublicAuthorization()
        .replace("Basic", "")
        .replace(" ", "")
        .trim()}`
    );
  };
  render() {

    
       

    return (

      <Templates.Default.BasePageRoute2
        localUrl={localUrl}
        dataPage={this.props.DataPage}
      >
              <section class="section">
<div className="columns">
            <div className="column">
            {this.titulo()}
            </div>
        </div>

        <div className="columns">
            <div className="column">
            <table class="table">
  <thead>
    <tr>
        <th>N°</th>
      <th>{this.props.language('nombre_cientifico')}</th>
      <th>{this.props.language('familia')}</th>
      <th>{this.props.language('total_operaciones')}</th>
      <th>{this.props.language('cat_cites')}</th>
      <th>{this.props.language('cat_uicn')}</th>
      <th>{this.props.language('nombre_comun')}</th>
      <th>{this.props.language('opciones')}</th>

    </tr>
  </thead>

  <tbody>
    
        {this.information()}


  </tbody>
</table>
            </div>
        </div>
        
              </section>      
        
      </Templates.Default.BasePageRoute2>

    );
  }
}

export default connect(getMapStateDefault(), {
  set_datapage,
  seDatatDocumentos,
  checkDataDirectorio,
})(Public);
